"use client";

import * as React from "react";
import { StaticImageData } from "next/image";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import LinkWithLang, {
  type LinkRouteDefaults,
} from "@stadium/shared/src/components/link-with-lang";
import Multimedia from "@stadium/shared/src/components/shared/multimedia";

import { B_10, BANNER_DEFAULTS } from "@stadium/shared/src/helpers/plasmic/static-slices";
import { type LinkWithLangType } from "@stadium/shared/src/constants/stores/routes";

import styles from "./main.module.scss";

export interface B10Props {
  // Content
  heading?: string;
  description?: string;

  // CTA
  buttonText?: string;
  buttonLinkType?: string;
  buttonOpenInNewTab?: boolean;
  buttonOtherUrl?: string;
  buttonCategorySlug?: string;

  mobileImg?: string | StaticImageData;
  desktopImg?: string | StaticImageData;
  imageAlt?: string;

  // Layout & Styling
  backgroundColor?: string;
  className?: string;
  linkRouteDefaults?: LinkRouteDefaults;
}

const B10: React.FC<Readonly<B10Props>> = ({
  heading = BANNER_DEFAULTS[B_10].heading,
  description = BANNER_DEFAULTS[B_10].description,
  buttonText = BANNER_DEFAULTS[B_10].buttonText,
  buttonLinkType = BANNER_DEFAULTS[B_10].buttonLinkType,
  buttonOpenInNewTab = false,
  buttonOtherUrl,
  buttonCategorySlug,
  imageAlt = BANNER_DEFAULTS[B_10].imageAlt,
  mobileImg = BANNER_DEFAULTS[B_10].mobileImg,
  desktopImg = BANNER_DEFAULTS[B_10].desktopImg,
  backgroundColor = BANNER_DEFAULTS[B_10].backgroundColor,
  className = "",
  linkRouteDefaults,
}) => {
  const { isMobileDevice, isTabletDevice } = React.useContext(CurrentDeviceContext);

  return (
    <section className={`${styles.sectionWrapper} ${className}`}>
      <div className={styles.divWrapper}>
        <div className={styles.contentWrapper}>
          <div className={styles.leftContentWrapper} style={{ backgroundColor }}>
            <div className={styles.leftContent}>
              <h2 className={styles.heading}>{heading}</h2>
              {description && <p className={styles.description}>{description}</p>}
              <div className={styles.buttonWrapper}>
                {buttonText && buttonLinkType && (
                  <LinkWithLang
                    {...linkRouteDefaults}
                    type={buttonLinkType as LinkWithLangType}
                    data={{
                      code: buttonCategorySlug,
                      url: buttonOtherUrl,
                    }}
                    target={buttonOpenInNewTab ? "_blank" : "_self"}
                    showExternalLinkIcon={buttonOpenInNewTab}
                    className={styles.primaryOutlineBtn}
                  >
                    {buttonText}
                  </LinkWithLang>
                )}
              </div>
            </div>
          </div>

          <div className={styles.rightContent}>
            {isMobileDevice || isTabletDevice ? (
              <Multimedia type="image" src={mobileImg} alt={imageAlt} className={styles.image} />
            ) : (
              <Multimedia type="image" src={desktopImg} alt={imageAlt} className={styles.image} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default B10;
